import _slicedToArray from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import { assertTokenProviderConfig } from '@aws-amplify/core/internals/utils';
import { getAuthStorageKeys } from '../tokenProvider/TokenStore.mjs';
import { OAuthStorageKeys } from './types.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var V5_HOSTED_UI_KEY = 'amplify-signin-with-hostedUI';
var name = 'CognitoIdentityServiceProvider';

var DefaultOAuthStore = /*#__PURE__*/function () {
  function DefaultOAuthStore(keyValueStorage) {
    _classCallCheck(this, DefaultOAuthStore);

    this.keyValueStorage = keyValueStorage;
  }

  _createClass(DefaultOAuthStore, [{
    key: "clearOAuthInflightData",
    value: function () {
      var _clearOAuthInflightData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var authKeys;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                assertTokenProviderConfig(this.cognitoConfig);
                authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
                _context.next = 4;
                return Promise.all([this.keyValueStorage.removeItem(authKeys.inflightOAuth), this.keyValueStorage.removeItem(authKeys.oauthPKCE), this.keyValueStorage.removeItem(authKeys.oauthState)]);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function clearOAuthInflightData() {
        return _clearOAuthInflightData.apply(this, arguments);
      }

      return clearOAuthInflightData;
    }()
  }, {
    key: "clearOAuthData",
    value: function () {
      var _clearOAuthData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var authKeys;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                assertTokenProviderConfig(this.cognitoConfig);
                authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
                _context2.next = 4;
                return this.clearOAuthInflightData();

              case 4:
                _context2.next = 6;
                return this.keyValueStorage.removeItem(V5_HOSTED_UI_KEY);

              case 6:
                return _context2.abrupt("return", this.keyValueStorage.removeItem(authKeys.oauthSignIn));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function clearOAuthData() {
        return _clearOAuthData.apply(this, arguments);
      }

      return clearOAuthData;
    }()
  }, {
    key: "loadOAuthState",
    value: function loadOAuthState() {
      assertTokenProviderConfig(this.cognitoConfig);
      var authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
      return this.keyValueStorage.getItem(authKeys.oauthState);
    }
  }, {
    key: "storeOAuthState",
    value: function storeOAuthState(state) {
      assertTokenProviderConfig(this.cognitoConfig);
      var authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
      return this.keyValueStorage.setItem(authKeys.oauthState, state);
    }
  }, {
    key: "loadPKCE",
    value: function loadPKCE() {
      assertTokenProviderConfig(this.cognitoConfig);
      var authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
      return this.keyValueStorage.getItem(authKeys.oauthPKCE);
    }
  }, {
    key: "storePKCE",
    value: function storePKCE(pkce) {
      assertTokenProviderConfig(this.cognitoConfig);
      var authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
      return this.keyValueStorage.setItem(authKeys.oauthPKCE, pkce);
    }
  }, {
    key: "setAuthConfig",
    value: function setAuthConfig(authConfigParam) {
      this.cognitoConfig = authConfigParam;
    }
  }, {
    key: "loadOAuthInFlight",
    value: function () {
      var _loadOAuthInFlight = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var authKeys;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                assertTokenProviderConfig(this.cognitoConfig);
                authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
                _context3.next = 4;
                return this.keyValueStorage.getItem(authKeys.inflightOAuth);

              case 4:
                _context3.t0 = _context3.sent;
                return _context3.abrupt("return", _context3.t0 === 'true');

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadOAuthInFlight() {
        return _loadOAuthInFlight.apply(this, arguments);
      }

      return loadOAuthInFlight;
    }()
  }, {
    key: "storeOAuthInFlight",
    value: function () {
      var _storeOAuthInFlight = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(inflight) {
        var authKeys;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                assertTokenProviderConfig(this.cognitoConfig);
                authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
                _context4.next = 4;
                return this.keyValueStorage.setItem(authKeys.inflightOAuth, "".concat(inflight));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function storeOAuthInFlight(_x) {
        return _storeOAuthInFlight.apply(this, arguments);
      }

      return storeOAuthInFlight;
    }()
  }, {
    key: "loadOAuthSignIn",
    value: function () {
      var _loadOAuthSignIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _yield$this$keyValueS, _yield$this$keyValueS2;

        var authKeys, isLegacyHostedUISignIn, _ref, _ref2, isOAuthSignIn, preferPrivateSession;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                assertTokenProviderConfig(this.cognitoConfig);
                authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
                _context5.next = 4;
                return this.keyValueStorage.getItem(V5_HOSTED_UI_KEY);

              case 4:
                isLegacyHostedUISignIn = _context5.sent;
                _context5.next = 7;
                return this.keyValueStorage.getItem(authKeys.oauthSignIn);

              case 7:
                _context5.t2 = _yield$this$keyValueS2 = _context5.sent;
                _context5.t1 = _context5.t2 === null;

                if (_context5.t1) {
                  _context5.next = 11;
                  break;
                }

                _context5.t1 = _yield$this$keyValueS2 === void 0;

              case 11:
                if (!_context5.t1) {
                  _context5.next = 15;
                  break;
                }

                _context5.t3 = void 0;
                _context5.next = 16;
                break;

              case 15:
                _context5.t3 = _yield$this$keyValueS2.split(',');

              case 16:
                _context5.t4 = _yield$this$keyValueS = _context5.t3;
                _context5.t0 = _context5.t4 !== null;

                if (!_context5.t0) {
                  _context5.next = 20;
                  break;
                }

                _context5.t0 = _yield$this$keyValueS !== void 0;

              case 20:
                if (!_context5.t0) {
                  _context5.next = 24;
                  break;
                }

                _context5.t5 = _yield$this$keyValueS;
                _context5.next = 25;
                break;

              case 24:
                _context5.t5 = [];

              case 25:
                _ref = _context5.t5;
                _ref2 = _slicedToArray(_ref, 2);
                isOAuthSignIn = _ref2[0];
                preferPrivateSession = _ref2[1];
                return _context5.abrupt("return", {
                  isOAuthSignIn: isOAuthSignIn === 'true' || isLegacyHostedUISignIn === 'true',
                  preferPrivateSession: preferPrivateSession === 'true'
                });

              case 30:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loadOAuthSignIn() {
        return _loadOAuthSignIn.apply(this, arguments);
      }

      return loadOAuthSignIn;
    }()
  }, {
    key: "storeOAuthSignIn",
    value: function () {
      var _storeOAuthSignIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(oauthSignIn) {
        var preferPrivateSession,
            authKeys,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                preferPrivateSession = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
                assertTokenProviderConfig(this.cognitoConfig);
                authKeys = createKeysForAuthStorage(name, this.cognitoConfig.userPoolClientId);
                _context6.next = 5;
                return this.keyValueStorage.setItem(authKeys.oauthSignIn, "".concat(oauthSignIn, ",").concat(preferPrivateSession));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function storeOAuthSignIn(_x2) {
        return _storeOAuthSignIn.apply(this, arguments);
      }

      return storeOAuthSignIn;
    }()
  }]);

  return DefaultOAuthStore;
}();

var createKeysForAuthStorage = function createKeysForAuthStorage(provider, identifier) {
  return getAuthStorageKeys(OAuthStorageKeys)(provider, identifier);
};

export { DefaultOAuthStore };